var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('learning-item-view',{attrs:{"item":_vm.item,"responses-complete":true,"show-complete":true}})}
var staticRenderFns = []

export { render, staticRenderFns }